import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';
import { type TenantUserRole } from '@/types/tenantUserRole';
import { auditDefaultPageSize } from '@/types/pagination';
import { getUsersResponseSchema } from '@/types/users';

const BASE = `${INTERNAL_V1}/users`;

export const getUser = async ({ id }: { id: string }, token?: string) => {
  const response = await damRequest('GET', `${BASE}/${id}`, token);

  return response;
  // return getUsersResponseSchema.parse(response);
};

export const getUsers = async (
  params: {
    pagination: { limit: number; offset: number };
    sort: { order: string; value: string };
    queryString: string;
    roles?: Array<TenantUserRole>;
  },
  token?: string,
) => {
  const searchParams = new URLSearchParams({
    offset: String(params.pagination.offset),
    limit: String(params.pagination.limit),
    filterQuery: params.queryString,
    sortBy: params.sort.value,
    sortOrder: params.sort.order,
  });

  params.roles?.forEach((role) => searchParams.append('roles[]', role));

  const response = await damRequest('GET', `${BASE}?${searchParams.toString()}`, token);

  return getUsersResponseSchema.parse(response);
};

export const inviteUser = async (body: object, token?: string) => {
  const response = await damRequest('POST', `${BASE}/invitation`, token, { body });

  return response;
};

export const deleteUser = ({ id }: { id: string }, token?: string) => damRequest('DELETE', `${BASE}/${id}`, token);

export const getUserAuditLog = async (
  params?: { id?: string; pagination?: { offset: number; limit: number } },
  token?: string,
) => {
  const query = new URLSearchParams({
    offset: String(params?.pagination?.offset ?? 0),
    limit: String(params?.pagination?.limit ?? auditDefaultPageSize),
  }).toString();

  const response = await damRequest('GET', `${BASE}/${params?.id}/audit?${query}`, token);
  return response;
};

export const updateUser = async ({ id, body }: { id: string; body: object }, token?: string) => {
  const response = await damRequest('PATCH', `${BASE}/${id}`, token, { body });

  return response;
};
